import { inferRouterOutputs } from "@trpc/server/unstable-core-do-not-import";
import type { AppRouter } from "cadendar-trpc-server";
import StatsLines from "./StatsLines";
import PeriodComparison from "./PeriodComparison";
import WeeklyFillStats from "./WeeklyFillStats";
import ProspectiveFillStats from "./ProspectiveFillStats";

const euroFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
});

type StatsOutput = inferRouterOutputs<AppRouter>["stats"]["get"];

type ExtendedStats = NonNullable<StatsOutput> & {
  futureDoctolibAvailableSlots: number;
};

interface StatsPanelProps {
  statsObject: ExtendedStats | null;
}

const StatsPanel = (props: StatsPanelProps) => {
  const { statsObject } = props;

  const stats = statsObject
    ? [
        {
          labelStat: "Nombre de Patients",
          value: statsObject.nbrpatients.toString(),
        },
        {
          labelStat: "Nombre de 1ères consultations",
          value: statsObject.nbrpremiereconsult.toString(),
        },
        {
          labelStat: "Nombre de patients PP",
          value: statsObject.nbrpatientspp.toString(),
        },
        {
          labelStat: "Stats calculées le",
          value: statsObject.date.toLocaleString(),
        },
      ]
    : [];

  return (
    <div>
      <PeriodComparison />
      <WeeklyFillStats />
      <ProspectiveFillStats />
      {statsObject ? <StatsLines stats={stats} /> : null}
      {statsObject?.periods.map((period) => (
        <div key={period.key} style={{ marginTop: "1rem" }}>
          <h3 style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            {period.label}
          </h3>
          <StatsLines
            stats={[
              {
                labelStat: "Patients uniques vus",
                value: period.uniqueSeenPatients.toString(),
              },
              {
                labelStat: "Parmi eux, patients de retour",
                value: period.returningSeenPatients.toString(),
              },
              {
                labelStat: "Nouveaux patients",
                value: period.newPatients.toString(),
              },
              {
                labelStat: "CA encaissé",
                value: euroFormatter.format(period.collectedRevenue),
              },
              {
                labelStat: "  dont Doctolib",
                value: period.newPatientsDoctolib.toString(),
              },
              {
                labelStat: "  dont Cadendar Web",
                value: period.newPatientsCadenweb.toString(),
              },
              {
                labelStat: "  dont AptRequest",
                value: period.newPatientsAptRequest.toString(),
              },
              {
                labelStat: "  dont autres canaux",
                value: period.newPatientsOtherChannel.toString(),
              },
            ]}
          />
        </div>
      ))}
      {statsObject ? (
        <div style={{ marginTop: "1rem" }}>
          <StatsLines
            stats={[
              {
                labelStat: "Cases Doctolib disponibles",
                value: statsObject.futureDoctolibAvailableSlots.toString(),
              },
            ]}
          />
        </div>
      ) : null}
    </div>
  );
};

export default StatsPanel;
